export default "__VITE_ASSET__c87802b9__"